import {useBrandShopIdentifier} from '../../BrandHub/utils/useBrandShopIdentifier';
import {useCategoryIdentifier} from '../../BrandHub/utils/useCategoryIdentifier';

export const useBrandShopIdentifierFooter = () => {
  const brandShopIdentifier = useBrandShopIdentifier();
  const categoryIdentifier = useCategoryIdentifier();

  return brandShopIdentifier?.id !== -1
    ? {
        brand: {
          identifier: brandShopIdentifier,
        },
        category: categoryIdentifier,
      }
    : null;
};
